module.exports = __webpack_public_path__ + "static/media/sopt29ru.d03f4e9f.pdf";